import type { GhostDto, GhostPersonDto } from '../../../types/turf'

/** "Who's there": people per position, most first (ties by name). A blank position counts as "Other". */
export function positionCounts(people: GhostPersonDto[]): { position: string; count: number }[] {
  const counts = new Map<string, number>()
  for (const p of people) {
    const position = p.position?.trim() || 'Other'
    counts.set(position, (counts.get(position) ?? 0) + 1)
  }
  return [...counts.entries()]
    .map(([position, count]) => ({ position, count }))
    .sort((a, b) => b.count - a.count || a.position.localeCompare(b.position))
}

/** After an add at one ghost: drop that ghost, take the added people out of every other ghost
 *  (a person can qualify at a home and a worksite), and drop any ghost left with nobody. */
export function pruneGhostsAfterAdd(ghosts: GhostDto[], addedKey: string, addedContactIds: string[]): GhostDto[] {
  const added = new Set(addedContactIds)
  return ghosts
    .filter(g => g.key !== addedKey)
    .map(g => (g.people.some(p => added.has(p.contactId))
      ? { ...g, people: g.people.filter(p => !added.has(p.contactId)) }
      : g))
    .filter(g => g.people.length > 0)
}
